import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';

type Props = {};

export const useExport = (props: Props) => {
    const [isPrinting, setIsPrinting] = useState(false);
    const tableRef = useRef<any>();

    const handleReactToPrint = useReactToPrint({
        content: () => tableRef.current,
        onAfterPrint: () => {
            setIsPrinting(false);
        },
    });

    return {
        tableRef,
        handlePrint: () => {
            setIsPrinting(true);

            setTimeout(() => handleReactToPrint(), 1);
        },
        isPrinting,
    };
};

/**
 * The Excel export of the manual-orders screen. The export table (every passenger x every day) is not kept
 * in the page — it cost about a second of every load with 1,500 passengers (measured 2026-11-01). A click
 * requests it; the screen mounts it while `isExcelRequested`; once it is in the DOM this effect runs the
 * download and clears the request — also when the download throws, so the buttons never stay blocked.
 * @param downloaderRef - the react-html-table-to-excel instance (ExcelDownloader)
 */
export const useExcelExportRequest = (downloaderRef: React.MutableRefObject<{ handleDownload: () => void } | null>) => {
    const [isExcelRequested, setIsExcelRequested] = useState(false);

    useEffect(() => {
        if (!isExcelRequested) return;
        try {
            downloaderRef.current?.handleDownload();
        } catch (error) {
            console.error(error);
        } finally {
            setIsExcelRequested(false);
        }
    }, [downloaderRef, isExcelRequested]);

    const requestExcel = useCallback(() => setIsExcelRequested(true), []);

    return { isExcelRequested, requestExcel };
};
